import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const absUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u);

// Turn a pasted embed code or share URL (YouTube, Vimeo, SoundCloud, Bandcamp…) into an iframe src.
export const embedSrcFrom = (raw) => {
  const s = (raw || "").trim();
  if (!s) return "";
  const iframe = s.match(/<iframe[^>]*\ssrc=["']([^"']+)["']/i);
  if (iframe) return iframe[1];
  const yt = s.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|live\/|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/i);
  if (yt) {
    const t = s.match(/[?&](?:t|start)=(\d+)/);
    return `https://www.youtube.com/embed/${yt[1]}${t ? `?start=${t[1]}` : ""}`;
  }
  const vimeo = s.match(/vimeo\.com\/(?:video\/)?(\d+)/i);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;
  return /^https?:\/\//i.test(s) ? s : "";
};

export const shareLink = async ({ title, text, url }) => {
  try {
    if (navigator.share) { await navigator.share({ title, text, url }); return; }
  } catch (e) { if (e?.name === "AbortError") return; }
  try { await navigator.clipboard.writeText(url); toast.success("Link copied — paste it anywhere"); }
  catch { window.prompt("Copy this link", url); }
};
